import { Routes, RouterModule } from "@angular/router";
import { AdminSetupComponent } from "./index";

import { CommunicationMaintenanceComponent } from "./communicationmaintenance/communicationmaintenance.component";
import { AddNotificationComponent } from "./communicationmaintenance/addnotification/addnotification.component";
import { AlertMaintenanceComponent } from "./alertmaintenance/alertmaintenance.component";
import { ActionMaintenanceComponent } from "./actionmaintenance/actionmaintenance.component";
import { ActionMaintenanceSBTComponent } from "./actionmaintenancesbt/actionmaintenancesbt.component";
import { InfractionMaintenanceComponent } from "./infractionmaintenance/infractionmaintenance.component";
import { InfractionMaintenanceSBTComponent } from "./infractionmaintenancesbt/infractionmaintenancesbt.component";
import { SoundMaintenanceComponent } from "./soundmaintenance/soundmaintenance.component";
import { CalendarmaintenanceComponent } from "./calendarmaintenance/calendarmaintenance.component";
import { ClassAttendanceExcuseSetupComponent } from "./class-attendance-excuse-setup/class-attendance-excuse-setup.component";
import { ExcuseSetupComponent } from "./excuse-setup/excuse-setup.component";
import { HomeroomSetupComponent } from "./homeroom-setup/homeroom-setup.component";
import { SchoolDaySetupComponent } from "./school-day-setup/school-day-setup.component";
import { TimeScanTypeSetupComponent } from "./time-scan-type-setup/time-scan-type-setup.component";
import { AcademySetupComponent } from "./academy-setup/academy-setup.component";
import { BellScheduleSetupComponent } from "./bell-schedule-setup/bell-schedule-setup.component";
import { CourseSetupComponent } from "./course-setup/course-setup.component";
import { SchoolIncidentTypeSetupComponent } from "./school-incident-type-setup/school-incident-type-setup.component";
import { PBISSetupComponent } from "./pbissetup/pbissetup.component";
import { FineTypeSetupComponent } from "./fine-type-setup/fine-type-setup.component";
import { GuardianTypeSetupComponent } from "./guardian-type-setup/guardian-type-setup.component";
import { PBISMaintenanceComponent } from "./pbismaintenance/pbismaintenance.component";
import { MealTypeMaintenanceComponent } from "./meal-type-maintenance/meal-type-maintenance.component";
import { LockerMaintenanceComponent } from "./locker-maintenance/locker-maintenance.component";
import { AutoPBISSetupComponent } from "./auto-pbissetup/auto-pbissetup.component";
import { ScanStationReminderSetupComponent } from "./scan-station-reminder-setup/scan-station-reminder-setup.component";
import { AuthguardService } from "../master/services";
import { BlockListSetupComponent } from "./block-list-setup/block-list-setup.component";
import { RoomSetupComponent } from "./room-setup/room-setup.component";

export const AdminSetupRoutes: Routes = [
	{ path: "", redirectTo: "/adminsetup/academy", pathMatch: "full" },
	{
		path: "academy",
		data: { title: "Academy Maintenance" },
		component: AcademySetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "classattendanceexcuse",
		data: { title: "Class Excuse Maintenance" },
		component: ClassAttendanceExcuseSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "excuse",
		data: { title: " Excuse Maintenance" },
		component: ExcuseSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "finetype",
		data: { title: " Fine Type Maintenance" },
		component: FineTypeSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "homeroom",
		data: { title: "Homeroom Maintenance" },
		component: HomeroomSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "guardian",
		data: { title: "Guardian Type Maintenance" },
		component: GuardianTypeSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "course",
		data: { title: "Course Maintenance" },
		component: CourseSetupComponent,
		canActivate: [AuthguardService],
	}, //New version
	{
		path: "schoolday",
		data: { title: "SchoolDay Maintenance" },
		component: SchoolDaySetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "timescantype",
		data: { title: "TimeScanType Maintenance" },
		component: TimeScanTypeSetupComponent,
		canActivate: [AuthguardService],
	},
	// { path: 'scheduler', data: { title: 'Communication Maintenance' }, component: CommunicationMaintenanceComponent },
	{
		path: "scheduler/:schoolID",
		data: { title: "Add Notification", HideSelector: true },
		component: AddNotificationComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "editnotification/:schoolID/:notificationTypeID",
		data: { title: "Edit Notification", HideSelector: true },
		component: AddNotificationComponent,
		canActivate: [AuthguardService],
	},

	{
		path: "merit",
		data: { title: "Merit/Demerit Maintenance" },
		component: PBISSetupComponent,
		canActivate: [AuthguardService],
	}, //Old
	{
		path: "pbis",
		data: { title: "PBIS Point Maintenance" },
		component: PBISMaintenanceComponent,
		canActivate: [AuthguardService],
	}, //New 10.9
	{
		path: "autopbis",
		data: { title: "Auto PBIS Points" },
		component: AutoPBISSetupComponent,
		canActivate: [AuthguardService],
	}, //New 10.12

	{
		path: "alert",
		data: { title: "Alert Maintenance" },
		component: AlertMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "penalty",
		data: { title: "Action Maintenance" },
		component: ActionMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "penaltysbm",
		data: { title: "Action Maintenance SBM" },
		component: ActionMaintenanceSBTComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "infraction",
		data: { title: "Infraction Maintenance" },
		component: InfractionMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "infractionsbm",
		data: { title: "Infraction Maintenance SBM" },
		component: InfractionMaintenanceSBTComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "sound",
		data: { title: "Sound Maintenance" },
		component: SoundMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "calendar",
		data: { title: "Calendar Maintenance" },
		component: CalendarmaintenanceComponent,
		canActivate: [AuthguardService],
	},
	// { path: 'location', data: { title: 'Location Maintenance' }, component: LocationMaintenanceComponent },
	{ path: "location", redirectTo: "/multistation/location", pathMatch: "full", canActivate: [AuthguardService] },
	{
		path: "bellschedule",
		data: { title: "Bell Schedule Maintenance" },
		component: BellScheduleSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "schoolincidenttype",
		data: { title: "School Incident Type Maintenance" },
		component: SchoolIncidentTypeSetupComponent,
		canActivate: [AuthguardService],
	},

	{
		path: "mealtype",
		data: { title: "Meal Type Maintenance" },
		component: MealTypeMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "locker",
		data: { title: "Locker Maintenance" },
		component: LockerMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "reminder",
		data: { title: "ScanStation Reminder Maintenance" },
		component: ScanStationReminderSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "blocklist",
		data: { title: "ScanStation Block List Maintenance" },
		component: BlockListSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "room",
		data: { title: "Room Maintenance" },
		component: RoomSetupComponent,
		canActivate: [AuthguardService],
	},
];
